import { render } from "./EmailForm.vue?vue&type=template&id=16a328ca&lang=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__